<template>
  <div>
    <t-card v-loading="loading" class="card_common">
      <div>
        <!-- ボタン -->
        <t-row>
          <!-- 入荷 -->
          <t-col :span="8" class="col_common_center">
            <!-- UPD 2025/09/10 ZLL 課題_250905顧客からの改善したい点への対応 start↓ -->
            <!-- 日本権限の変更：権限(読み取り)が必要、権限(入力・修正)が不要　　　 -->
            <!-- <t-button
              round
              type="primary"
              class="button_common"
              ref="addBtn"
              @click="addClick()"
            > -->
            <t-button
              round
              type="primary"
              class="button_common"
              ref="addBtn"
              @click="addClick()"
              :disabled="!isDLUserLocal"
            >
              <!-- UPD 2025/09/10 ZLL 課題_250905顧客からの改善したい点への対応 end↑ -->

              <i class="el-icon-plus"></i>
              {{ $t("resource.checkReceInfo.crbReceGood") }}
            </t-button>
          </t-col>
          <!-- 削除 -->
          <t-col :span="8" class="col_common_center">
            <!-- UPD 2025/09/10 ZLL 課題_250905顧客からの改善したい点への対応 start↓ -->
            <!-- 日本権限の変更：権限(読み取り)が必要、権限(入力・修正)が不要　　　 -->
            <!-- <t-button
              round
              type="danger"
              class="button_common"
              ref="delBtn"
              @click="deleteClickSelected"
            > -->
            <t-button
              round
              type="danger"
              class="button_common"
              ref="delBtn"
              @click="deleteClickSelected"
              :disabled="!isDLUserLocal"
            >
              <!-- UPD 2025/09/10 ZLL 課題_250905顧客からの改善したい点への対応 end↑ -->
              <i class="el-icon-delete"></i>
              {{ $t("resource.sys.delete") }}
            </t-button>
          </t-col>
        </t-row>

        <!-- 検索条件 -->
        <div class="div_common_search">
          <t-divider>{{ $t("resource.sys.searchCondition") }}</t-divider>
          <div class="search">
            <t-form
              :model="searchConditionForm"
              :label-width="$t('widgetSize.search.labelWidth')"
            >
              <t-row>
                <t-col :span="1">&nbsp;</t-col>
                <t-col :span="12">
                  <div>
                    <!-- 入荷日 -->
                    <t-form-item
                      :label="$t('resource.checkReceInfo.crbReceDate')"
                    >
                      <t-date-picker
                        v-model="searchConditionForm.quoteDateRange"
                        :clearable="false"
                        type="daterange"
                        class="date_icon_center"
                        range-separator="～"
                        start-placeholder="開始日"
                        end-placeholder="終了日"
                        value-format="yyyy/MM/dd"
                        format="yyyy/MM/dd"
                        style="min-width: 20px; width: 75%; margin-top: 8px"
                        :editable="false"
                      >
                      </t-date-picker>
                    </t-form-item>
                  </div>
                </t-col>
                <t-col :span="5">
                  <!-- 入荷状態 -->
                  <t-form-item :label="$t('resource.checkReceInfo.crbStatus')">
                    <t-select
                      v-model="searchConditionForm.selectCrbStatus"
                      style="width: 100%"
                      clearable
                      :placeholder="$t('resource.sys.hidden')"
                    >
                      <t-option
                        v-for="item in recStatusList"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                      >
                      </t-option>
                    </t-select>
                  </t-form-item>
                </t-col>

                <t-col :span="3">&nbsp;</t-col>
              </t-row>
              <t-row>
                <t-col :span="1">&nbsp;</t-col>
                <t-col :span="17" class="col_block_left">
                  <!-- 検索キー -->
                  <t-form-item :label="$t('resource.sys.searchKey')">
                    <t-input
                      clearable
                      v-model="searchConditionForm.searchWord"
                      maxLength="50"
                      style="width: 100%"
                    >
                    </t-input>
                  </t-form-item>
                </t-col>

                <t-col :span="1">&nbsp;</t-col>

                <t-col :span="4" class="center">
                  <!-- 検索 -->
                  <t-button
                    round
                    type="primary"
                    class="button_common_search marginRight"
                    ref="searchBtn"
                    @click="searchClick()"
                  >
                    <i class="el-icon-search"></i
                    >{{ $t("resource.sys.search") }}
                  </t-button>
                </t-col>

                <t-col
                  :span="parseInt($t('widgetSize.TRANSPORT.SPACE_SPAN_ONE'))"
                  class="col_block_left"
                  >&nbsp;</t-col
                >
              </t-row>
            </t-form>
          </div>
        </div>
      </div>

      <div class="div_content">
        <t-table
          ref="checkRecenTableData"
          :data="checkRecenTableData"
          class="table_common"
          header-cell-class-name="bg-default"
          :height="maxheight"
          @row-dblclick="updateClick"
          border
        >
          <t-table-column type="selection" class-name="cell_txt_center" />

          <!-- 　入荷状態 -->
          <t-table-column
            prop="crbStatus"
            :label="$t('resource.checkReceInfo.crbStatus')"
            :min-width="
              flexColumnWidthFunc(
                $t('resource.checkReceInfo.crbStatus'),
                'crbStatus'
              )
            "
            class-name="cell_txt_center"
          >
            <template #default="{ row }"
              ><div class="div_status">
                <span
                  :class="row.crbStatusColor"
                  class-name="cell_txt_center"
                  class="status"
                  >●</span
                >
                <span class="order-status" class-name="cell_txt_center"
                  >{{ row.crbStatusName }}
                </span>
              </div>
            </template>
          </t-table-column>

          <t-table-column
            v-for="(column, index) in columns"
            :key="index"
            :type="column.type"
            :prop="column.prop"
            :label="column.label"
            :min-width="column.width"
            :class-name="column.class"
            :show-overflow-tooltip="column.overflowTooltip"
          >
          </t-table-column>
        </t-table>
        <t-pagination
          align="right"
          :current-page.sync="pageNo"
          :page-size="pageSize"
          :page-sizes="getPageDataCountFunc()"
          layout="total, sizes, prev, pager, next"
          :total="checkRecenBasicDatalength"
          @current-change="pageChange"
          @size-change="handleSizeChange"
        >
        </t-pagination>
      </div>
    </t-card>
  </div>
</template>
<script>
import { t } from "@/locales";
//import { DateFormat } from "@/utils/filter";
import { ShowCheckReceInfoEditDialog } from "@/components/Dialog";
import {
  deleteReceInfo,
  getCheckReceBasicInfo,
} from "@/services/checkReceInfo";
import {
  getDialogContentHeight,
  getOneMonthAgoArray,
} from "@/utils/comFunction";
import { DIALOG_LINE_HEIGHT, GetPageDataCount } from "@/utils/const";
import { flexColumnWidth, setColumnWidth } from "@/utils/table";
import { Message, Modal } from "@tellus/component";
//import moment from "moment";
export default {
  data() {
    return {
      searchConditionForm: {
        // 入荷日
        quoteDateRange: "",
        // 入荷開始日
        startDate: "",
        // 入荷終了日
        endDate: "",
        // DEL 2025/04/16 ZLL 課題_250328~250416顧客からの改善したい点への対応 start↓
        // 運送状態
        // selectCrbTransStatus: "",
        // DEL 2025/04/16 ZLL 課題_250328~250416顧客からの改善したい点への対応 end↑
        // 入荷状態
        selectCrbStatus: "",
        // 検索キー
        searchWord: "",
      },

      //基本情報のheight
      basicHeight: DIALOG_LINE_HEIGHT * 3,
      //明細情報のheight
      detailHeight: getDialogContentHeight(
        window.innerHeight,
        0,
        DIALOG_LINE_HEIGHT,
        20
      ),

      // 検索入荷基本情報の値
      checkRecenBasicData: [],

      //　入荷状態
      recStatusList: [],

      //　運送状態
      tranStatusList: [],

      // ADD 2025/09/10 ZLL 課題_250905顧客からの改善したい点への対応 start↓
      //権限（false: 日本、true：大連（ 品質保証部））
      isDLUserLocal: false,
      // ADD 2025/09/10 ZLL 課題_250905顧客からの改善したい点への対応 end↑

      columns: [
        // 入荷No.
        {
          prop: "crbReceNo",
          label: t("resource.checkReceInfo.crbReceNo"),
          width: t("widgetSize.tableCommon.defaultWidth"),
          class: "cell_txt_left",
          overflowTooltip: false,
        },
        // 入荷日
        {
          prop: "crbReceDate",
          label: t("resource.checkReceInfo.crbReceDate"),
          width: t("widgetSize.tableCommon.defaultWidth"),
          class: "cell_txt_center",
          overflowTooltip: true,
        },
        // 仕入先
        {
          prop: "crbSupInfo",
          label: t("resource.checkReceInfo.crbSupInfo"),
          width: t("widgetSize.tableCommon.defaultWidth"),
          class: "cell_txt_left",
          overflowTooltip: true,
        },
        // 連絡担当者
        {
          prop: "crbUserName",
          label: t("resource.checkReceInfo.crbUserName"),
          width: t("widgetSize.tableCommon.defaultWidth"),
          class: "cell_txt_left",
          overflowTooltip: true,
        },
        // DEL 2025/04/16 ZLL 課題_250328~250416顧客からの改善したい点への対応 start↓
        // // 運送状態
        // {
        //   prop: "crbTransStatusName",
        //   label: t("resource.checkReceInfo.crbTransStatus"),
        //   width: t("widgetSize.tableCommon.defaultWidth"),
        //   class: "cell_txt_center",
        //   overflowTooltip: false,
        // },
        // DEL 2025/04/16 ZLL 課題_250328~250416顧客からの改善したい点への対応 end↑
      ],
      // 現在のページ数
      pageNo: 1,

      // 待ち
      loading: true,

      // データ個数/各ページ
      pageSize: 20,

      // 検索入荷基本情報の数
      checkRecenBasicDatalength: 0,
      maxheight: window.innerHeight - 291.5 - 10,
    };
  },

  watch: {
    // 入荷日
    "searchConditionForm.quoteDateRange"(value) {
      // 入荷日処理
      this.editDate(value);
    },
  },

  mounted() {
    // ADD 2025/09/10 ZLL 課題_250905顧客からの改善したい点への対応 start↓
    // 権限の取得
    this.isDLUserLocal = sessionStorage.getItem("isDLUser") === "true";
    // ADD 2025/09/10 ZLL 課題_250905顧客からの改善したい点への対応 end↑

    //画面の初期化
    this.init();

    //テーブルの高さを監視する
    window.addEventListener("resize", this.handleResize);

    //列幅に自動調整
    setColumnWidth(this.columns, this.checkRecenTableData);
  },

  computed: {
    checkRecenTableData: {
      get() {
        return this.checkRecenBasicData.slice(
          (this.pageNo - 1) * this.pageSize,
          this.pageNo * this.pageSize
        );
      },
    },

    recordTotal() {
      // 検索入荷基本情報の長さ
      return this.checkRecenBasicData.length;
    },
  },

  methods: {
    //テーブルの高さを設定する
    handleResize() {
      this.maxheight = window.innerHeight - 291.5 - 10; //291.5 = 165.5 + 20 + 10 + 58 + 32 + 6
    },

    // 初期化
    init() {
      this.dateInit();
      this.searchClick();
    },

    //入荷日の初期化
    dateInit() {
      // 入荷日
      this.searchConditionForm.quoteDateRange = getOneMonthAgoArray();

      // 入荷開始日
      this.searchConditionForm.startDate =
        this.searchConditionForm.quoteDateRange[0];

      // 入荷終了日
      this.searchConditionForm.endDate =
        this.searchConditionForm.quoteDateRange[1];
    },

    // 入荷日処理
    editDate(value) {
      if (Array.isArray(value) && value.length >= 2) {
        // 入荷開始日
        this.searchConditionForm.startDate = value[0];
        // 入荷終了日
        this.searchConditionForm.endDate = value[1];
      } else {
        // 入荷開始日
        this.searchConditionForm.startDate = null;
        // 入荷終了日
        this.searchConditionForm.endDate = null;
      }
    },

    // 新规
    addClick() {
      //  検査室入荷詳細画面
      ShowCheckReceInfoEditDialog(
        { isAdd: true },
        t("resource.checkReceInfo.crdCheckReceDetailInfo"),
        (target) => {
          this.searchClick();
        }
      );

      // フォーカス削除
      this.$refs.addBtn.$el.blur();
    },

    //编辑
    updateClick(row) {
      //  検査室入荷詳細画面
      ShowCheckReceInfoEditDialog(
        { isAdd: false, RowData: row },
        t("resource.checkReceInfo.crdCheckReceDetailInfo"),
        (target) => {
          this.searchClick();
        }
      );
    },

    // 検索
    searchClick() {
      this.loading = true;

      // 検索キー
      this.searchConditionForm.searchWord =
        this.searchConditionForm.searchWord.trim();

      // 検索入荷基本情報
      getCheckReceBasicInfo(this.searchConditionForm)
        .then((res) => {
          // 検索入荷基本情報の値
          this.checkRecenBasicData = res.CheckReceBasicDtos;

          // 入荷状態List
          this.recStatusList = res.StatusList;

          // 運送状態List
          this.tranStatusList = res.TranStatusList;

          // 検索入荷基本情報の数
          this.checkRecenBasicDatalength = this.checkRecenBasicData.length;

          Message.showSuccess(t("message.COMMON_MESSAGE.SEARCH_SUCCESS"));
        })
        .catch((err) => {
          if (err.data != null) {
            Message.showError(
              t("message.COMMON_MESSAGE." + err.data.Messages[0].Message)
            );
          } else {
            Message.showError(t("message.COMMON_MESSAGE.SEARCH_FAILURE"));
          }
        })
        .finally(() => {
          // 閉じるのを待ちます
          this.loading = false;
        });

      if (typeof this.$refs.searchBtn !== "undefined") {
        // フォーカス削除
        this.$refs.searchBtn.$el.blur();
      }
    },

    //複数行データの削除
    deleteClickSelected() {
      // フォーカス削除
      this.$refs.delBtn.$el.blur();

      let data = this.$refs.checkRecenTableData.selection;

      if (data.length == 0) {
        Modal.showWarning("", t("message.COMMON_MESSAGE.PLEASE_SELECT_DATA"), {
          confirmButtonText: t("resource.COMMON_CONSTANT.CONFIRM"),
        });

        return;
      }

      // DEL 2025/04/16 ZLL 課題_250328~250416顧客からの改善したい点への対応 start↓
      // 運送した入荷データは削除できません
      // let hasApproved = data.some(
      //   (item) => item.crbTransStatus != FINAL_STR.TRANS_STATUS_NO_TRANS
      // );

      // if (hasApproved) {
      //   Modal.showError("", t("message.CHECK_RECE.HAS_TRAN_STATUS_MESSAGE"), {
      //     confirmButtonText: t("resource.COMMON_CONSTANT.CONFIRM"),
      //   });
      //   return;
      // }
      // DEL 2025/04/16 ZLL 課題_250328~250416顧客からの改善したい点への対応 end↑

      Modal.showWarning("", t("message.COMMON_MESSAGE.DELETE_CONFIRM_MSG"), {
        $type: "prompt",
        confirmButtonText: t("resource.COMMON_CONSTANT.YES"),
        cancelButtonText: t("resource.COMMON_CONSTANT.NO"),
        showCancelButton: true,
      }).then(() => {
        // 開始するのを待ちます
        this.loading = true;

        // 削除入荷情報;
        deleteReceInfo(data)
          .then((res) => {
            Message.showSuccess(t("message.COMMON_MESSAGE.DELETE_SUCCESS"));
          })
          .catch((err) => {
            if (err.data != null) {
              Message.showError(
                t("message.COMMON_MESSAGE." + err.data.Messages[0].Message)
              );
            } else {
              Message.showError(t("message.COMMON_MESSAGE.DELETE_FAILURE"));
            }
          })
          .finally(() => {
            this.searchClick();
          });
      });
    },

    // 翻页处理
    pageChange(val) {
      this.pageNo = val;
    },

    // 每页条数
    handleSizeChange(val) {
      this.pageNo = 1;
      this.pageSize = val;
    },

    // 每页数据条数
    getPageDataCountFunc() {
      return GetPageDataCount();
    },
    /**
     * el-table-column 自适应列宽
     * @param prop_label: 表名
     * @param table_data: 表格数据
     */
    flexColumnWidthFunc(label, prop) {
      return flexColumnWidth(label, prop, this.checkRecenTableData);
    },
  },
};
</script>
<style lang="scss" scope>
/* 使第二个 span 元素占据剩余空间，实现内容对齐 */
.order-status {
  flex: 1;
}
</style>
